import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Header";
import Footer from "../../components/Footer";
import axios from "axios";
import DetailPage from "../../components/Detail/DetailPageNew";

function Detail() {
  let [data, setData] = useState({
    name: "",
    images: [],
    price: "",
    desc: "",
  });
  let { slug } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    async function fetchData() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/properties/slug/${slug}`);
        setData(res.data);
      } catch (err) {
        setData(null);
      }
    }
    fetchData();
  }, [slug]);

  if (!data) return <div>Property not found</div>;

  return (
    <div>
      <Navbar diffHeader={true} />
      <DetailPage data={data} />
      <Footer />
    </div>
  );
}

export default Detail;
